import { createFileRoute } from '@tanstack/react-router'
import { RefreshCcw } from 'lucide-react'
import { useAuth } from '../lib/auth/useAuth'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { PageMain } from '@/components/page-main'

export const Route = createFileRoute('/auth-error')({
  component: AuthErrorPage,
})

function AuthErrorPage() {
  const { login } = useAuth()

  return (
    <PageMain className="flex min-h-screen items-center justify-center px-6">
      <Card className="w-full max-w-sm" role="alert">
        <CardHeader className="text-center space-y-2">
          <p
            aria-hidden
            className="text-xs uppercase tracking-widest text-muted-foreground lowercase"
          >
            hawk
          </p>
          <h1 className="text-2xl font-semibold tracking-tight text-destructive">
            Authentication Error
          </h1>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground text-center">
            Something went wrong during sign in. Please try again.
          </p>
          <Button onClick={login} className="w-full">
            <RefreshCcw className="size-4" aria-hidden />
            Try again
          </Button>
        </CardContent>
      </Card>
    </PageMain>
  )
}
